import getConfig from 'next/config';
import Rollbar from 'rollbar';

let instance;
export default instance ? instance : init();
export function init(payload: object = {}): any {
    if (instance) {
        return instance;
    } else {
        const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

        return instance = new Rollbar({
            accessToken: process.browser
                ? publicRuntimeConfig.ROLLBAR_KEY
                : serverRuntimeConfig.ROLLBAR_KEY,
            environment: publicRuntimeConfig.APP_ENV,
            autoInstrument: { log: false },
            verbose: publicRuntimeConfig.APP_ENV === 'development',
            payload: {
                ...payload,
            },
        });
    }
}
